/* Salty Paws - keeps the header cart badge honest. Aug 20 2026.

   THE PROBLEM
   Shopify serves page HTML from cache. The cart badge is baked into that HTML at
   render time, and the theme only updates it client-side on the page where you
   press Add to Cart. So the badge is whatever the cart held when that page was
   cached: add a shirt, go to another collection, and the number is missing or
   stale. Press Back onto a cached cart page and it says "your cart is empty".
   The cart itself is never wrong - only what is drawn on screen.

   THE FIX
   On every page load, read the real cart from /cart.js and rewrite the badge.
   One small request; the badge then always matches the cart.

   Oct 22 2026: Linda, Android phone via Messenger: add a shirt, go to checkout,
   press Back, and the bag showed empty although the cart still held the shirt.
   Reproduced once in Chrome too: the page came back from cache and the badge
   stayed hidden. The single read on load was not enough, so it now also reads
   the cart on every pageshow (not only bfcache restores), when the page becomes
   visible again or regains focus, twice more shortly after load, and puts the
   badge back if anything hides it while the cart has items.

   Pre-dates the shipping bar - reproduced on theme 163113631960, which loads
   neither sp-ship-bar.js nor this file. */
(function () {
  'use strict';

  var RELOAD_GUARD = 'sp-cart-reloaded';
  var lastCount = null;
  var watched = null;

  function onCartPage() {
    return /^\/cart(\/|$)/.test(location.pathname);
  }

  /* The cart page renders .cart-page--empty when Liquid saw an empty cart. */
  function renderedEmpty() {
    return !!document.querySelector('.cart-page--empty');
  }

  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function syncBubble(count) {
    var bubble = document.querySelector('[ref="cartBubble"]');
    if (!bubble) return;

    if (count > 0) {
      bubble.classList.remove('visually-hidden');
    } else {
      bubble.classList.add('visually-hidden');
    }

    var countEl = bubble.querySelector('[ref="cartBubbleCount"]');
    if (countEl) {
      if (count > 0) {
        countEl.classList.remove('hidden');
      } else {
        countEl.classList.add('hidden');
      }
      setText(countEl, count < 100 ? String(count) : '');
    }

    var label = bubble.querySelector('.visually-hidden');
    if (label && label !== countEl) setText(label, 'Total items in cart: ' + count + ' ');

    var icon = bubble.closest('cart-icon');
    if (icon) icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);

    var link = document.querySelector('a.action__cart') || document.querySelector('a[href="/cart"]');
    if (link) link.setAttribute('aria-label', 'Cart Total items in cart: ' + count);

    watch(bubble);
  }

  /* If other code hides the badge again while the cart has items, put it back.
     Only writes when the badge is hidden or shows 0, so it cannot loop and never
     fights the theme's own count change right after an add. */
  function watch(bubble) {
    if (watched === bubble || typeof MutationObserver === 'undefined') return;
    watched = bubble;
    new MutationObserver(function () {
      if (lastCount === null || lastCount === 0 || lastCount >= 100) return;
      var countEl = bubble.querySelector('[ref="cartBubbleCount"]');
      var hidden = bubble.classList.contains('visually-hidden') ||
        (countEl && (countEl.classList.contains('hidden') || /^0?$/.test(countEl.textContent.trim())));
      if (hidden) syncBubble(lastCount);
    }).observe(bubble, { attributes: true, childList: true, subtree: true, characterData: true });
  }

  /* The cart page cannot be patched line by line. If what is drawn disagrees with
     the real cart, reload once. The sessionStorage guard makes it impossible to
     loop even if the two never agree. */
  function fixCartPage(count) {
    var shown = renderedEmpty();
    var wrong = (count > 0 && shown) || (count === 0 && !shown);
    if (!wrong) {
      try { sessionStorage.removeItem(RELOAD_GUARD); } catch (e) {}
      return false;
    }
    var already = false;
    try { already = sessionStorage.getItem(RELOAD_GUARD) === '1'; } catch (e) {}
    if (already) return false;
    try { sessionStorage.setItem(RELOAD_GUARD, '1'); } catch (e) {}
    location.reload();
    return true;
  }

  function resync() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
        lastCount = count;
        if (onCartPage() && fixCartPage(count)) return;
        syncBubble(count);
      })
      .catch(function () { /* leave the page as it is */ });
  }

  function onLoad() {
    resync();
    /* Late theme scripts can redraw the header from the cached HTML; check again. */
    setTimeout(resync, 1000);
    setTimeout(resync, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoad);
  } else {
    onLoad();
  }

  /* Every show, including Back and Forward, whether or not it came from the bfcache. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) onLoad(); else resync();
  });

  /* In-app browsers (Messenger, Instagram) often resume a page without a pageshow.
     Not on the cart page, where a reload could land in the middle of a quantity change. */
  function resyncIfNotCart() {
    if (!onCartPage()) resync();
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resyncIfNotCart();
  });
  window.addEventListener('focus', resyncIfNotCart);

  /* After an add, let the theme's own update run first, then confirm the truth. */
  document.addEventListener('cart:update', function () {
    setTimeout(resync, 400);
  });
})();
